import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoadingProvider } from './context/LoadingContext';
import Layout from './components/Layout';
import InstallPrompt from './components/InstallPrompt';
import SessionWarning from './components/SessionWarning';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Viagens from './pages/Viagens';
import Reservas from './pages/Reservas';
import Encomendas from './pages/Encomendas';
import Usuarios from './pages/Usuarios';
import LeitoreQRCode from './pages/LeitoreQRCode';
import Relatorios from './pages/Relatorios';
import Bagagens from './pages/Bagagens';
import Despesas from './pages/Despesas';
import ContasPagar from './pages/ContasPagar';
import AccessDenied from './pages/AccessDenied';
import './App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function RequireRole({ children, roles, pageName }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) {
    return <AccessDenied allowedRoles={roles} pageName={pageName} />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="viagens" element={<Viagens />} />
        <Route path="reservas" element={<Reservas />} />
        <Route path="encomendas" element={<Encomendas />} />
        <Route path="bagagens" element={<Bagagens />} />
        <Route path="usuarios" element={
          <RequireRole roles={['admin']} pageName="Gerenciamento de Usuários">
            <Usuarios />
          </RequireRole>
        } />
        <Route path="leitor-qrcode" element={
          <RequireRole roles={['admin', 'operador']} pageName="Leitor QR Code">
            <LeitoreQRCode />
          </RequireRole>
        } />
        <Route path="relatorios" element={
          <RequireRole roles={['admin', 'financeiro']} pageName="Relatórios Financeiros">
            <Relatorios />
          </RequireRole>
        } />
        <Route path="despesas" element={
          <RequireRole roles={['admin', 'operador', 'financeiro']} pageName="Despesas">
            <Despesas />
          </RequireRole>
        } />
        <Route path="contas-pagar" element={
          <RequireRole roles={['admin', 'financeiro']} pageName="Contas a Pagar">
            <ContasPagar />
          </RequireRole>
        } />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LoadingProvider>
          <AppRoutes />
          <Toaster richColors position="top-right" />
          <InstallPrompt />
          <SessionWarning />
        </LoadingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
